const format = {
  european: 'MMM D, YYYY',
  usa: 'YYYY-MM-DD',
  'usa_display': 'Y-m-d',
  'usa_short': 'y-m-d',
  dMY: 'd-M-Y',
  DMY: 'D-M-YYYY',
  usaWithSlashDate: 'DD/MM/YYYY',
  usaTime: 'HH:mm',
  monthDisplay: 'MMM yyyy',
  reactDatepicker: 'dd MMM yyyy',
  usaDetailed: 'MMMM DD, YYYY',
  mmss: 'mm:ss',
  hhmmss: 'hh:mm:ss',
  'calendar_month_name': 'MMMM, YYYY',
  'calendar_schedule_time': 'hh:mm A',
};

export default { format };
